<swiper [config]="dynamicCategory().swiperConfig">
  @for (category of dynamicCategory().categories; track category) {
  <ng-template swiperSlide>
    <custom-dot-cms-uve-category-card
      [stylesCSS]="dynamicCategory().contentlet.listItemCssClass"
      [category]="category"
      [layout]="dynamicCategory().contentlet.layout"
    />
  </ng-template>
  }
</swiper>

<!-- <div class="animated-element image-wrapper shine"> -->
